import React from 'react';

const Star = ({extraClassName, color, width, height}) => {
  return (
    <svg
      className={extraClassName}
      width={width || '29'}
      height={height || '28'}
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.434 14.289L5.253 8.883L0.867 5.942H6.239L8.16 0.144999L10.115 5.942H15.453L11.067 8.883L12.92 14.289L8.16 10.838L3.434 14.289Z"
        fill={color || '#FFEA00'}
      />
    </svg>
  );
};

export default Star;
